// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xbzkJ","colBig":"styles_colBig__1DdY5","colSmall":"styles_colSmall__1hwrm"};